import Env from "constants/environment";

export const ROLLOUT_SHARED_AGENT_TOKEN = "ao_shared_agent_token";
export const ROLLOUT_APM_LOG_INTEGRATION = "ao_apm_log_integration";
export const ROLLOUT_CONTRACT_CREDIT_CARD = "ao_contract_credit_card";
export const ROLLOUT_ENABLE_CONTRACT_CHANGES = "ao_enable_contract_changes";
export const ROLLOUT_AZURE_INTEGRATION = "ao_azure_integration";
export const ROLLOUT_TRACE_LEVEL_ROOT_CAUSE = "ao_trace_level_root_cause";
export const ROLLOUT_TRACE_LEVEL_ROOT_CAUSE_ASYNC =
  "ao_trace_level_root_cause_async";
export const ROLLOUT_CONTRACT_INFRA_PACK = "ao_contract_infra_pack";
export const ROLLOUT_THEMES = "ao_themes";
export const ROLLOUT_COMMON_SETTINGS_INTEGRATION =
  "ao_common_settings_integration";
export const ROLLOUT_ALERT_TRIGGERED_STREAM_LIST =
  "ao_alert_triggered_stream_list";
export const ROLLOUT_SAML_SECURITY = "ao_saml_security";
export const ROLLOUT_COMBINED_NAV = "ao_combined_nav";
export const ROLLOUT_SERVICES_HIPCHAT = "ao_services_hipchat";
export const ROLLOUT_PINGDOM_CONVERGED = "ao_pingdom_converged";
export const ROLLOUT_HOST_PROCESSES_MODAL = "ao_host_processes_modal";
export const ROLLOUT_REENABLE_ONBOARDING = "ao_reenable_onboarding";
export const ROLLOUT_MISSING_PLUGINS = "ao_missing_plugins";
export const ROLLOUT_LIVE_CHAT = "ao_live_chat";
export const ROLLOUT_OLD_LIVE_CHAT_DEPRECATION = "ao_old_live_chat_deprecation";
export const AO_SERVICE_PAGINATION = "ao_service_pagination";
export const ROLLOUT_HOST_AND_CONTAINER_LIST_PAGINATION =
  "ao_host_and_container_list_pagination";

const Flag = props => {
  const { on, children } = props;

  if (flagOn(on)) {
    return [children];
  } else {
    return null;
  }
};

export const flagOn = flag => {
  if (!flag) {
    return false;
  }

  // if user is logged in, flags live here
  if (window.Session && window.Session.flags) {
    return window.Session.flags[flag];
  }

  // if no user is logged in, flags live here
  if (window.Auth && window.Auth.flags) {
    return window.Auth.flags[flag];
  }

  return false;
};

export const flagOnOrDevelopment = flag => Env.isDevelopment || flagOn(flag);

export default Flag;
